<template>
  <div>
    <li class="nav-item">
      <div
        class="nav-link show"
        :class="{ active }"
        @click="$emit('click', name)"
      >
        {{ displayName || name }}
      </div>
    </li>
  </div>
</template>

<script>
export default {
  props: {
    link: { type: String, default: "" },
    active: { type: Boolean, default: false },
    name: { type: String, default: "" },
    displayName: { type: String, default: null }
  },
  emits: ["click"]
};
</script>

<style lang="scss" scoped>
li.nav-item {
  cursor: pointer;
}
.nav-link {
  color: var(--sera-color-text-body, #6f767b) !important;
  &.active {
    font-weight: bold;
    color: var(---sera-color-core-blue-cobalt-blue-800, #0f3b95) !important;
  }
}
</style>
